<template>
  <div class="row">
    <div class="col-sm-4">
      <p>
        <span class="data-label d-xl-none">Screen Name</span>
        {{ screen.name }}
      </p>
    </div>
    <div class="col-sm-4">
      <p>
        <span class="data-label d-xl-none">Media Owner{{ mediaOwnerNames.length > 1 ? 's' : '' }}</span>
        {{ mediaOwnerNames.length > 0 ? mediaOwnerNames.join(', ') : '-' }}
      </p>
    </div>
    <div class="col-sm-2">
      <p>
        <span class="data-label d-xl-none">Panel ID</span>
        {{ screen.panel_id ? screen.panel_id : '-' }}
      </p>
    </div>
    <div class="col-sm-2 text-end">
      <c-button @click.prevent="click" class="btn btn-sm btn-success">
        Add Screen
      </c-button>
    </div>
  </div>
</template>

<script>
export default {

  props: {
    screen: {
      required: true,
      type: Object
    }
  },

  computed: {
    mediaOwnerNames () {
      if (this.screen.media_owners && this.screen.media_owners.length > 0) {
        return this.screen.media_owners.map(mo => mo.name)
      }
      return []
    }
  },

  methods: {
    click () {
      this.$emit('addScreen', this.screen)
    }
  }

}
</script>
